import ModelBase, {IModelBase} from '@/models/ModelBase'
import { KeyPair } from '@/types/KeyPair'
import {PostStatus} from "@/models/Post"

export interface IEventPage extends IModelBase {
  title?: string
  status?: PostStatus
  content?: string
  thumbnail_url?: string
}

export default class EventPage extends ModelBase {
  title = ''
  status: PostStatus = 'draft'
  content = ''
  thumbnail_url?: string

  constructor(defaults?: IEventPage) {
    super(defaults)
    if (defaults) {
      this.title = defaults.title
      this.status = defaults.status
      this.content = defaults.content
      this.thumbnail_url = defaults.thumbnail_url
    }
  }

  toParams(): KeyPair {
    return {
      title: this.title,
      status: this.status,
      content: this.content,
      thumbnail_url: this.thumbnail_url
    }
  }
}
